import { isAxiosError } from 'axios';
import { log } from '@/logger/logger.ts';
import { safeAxios } from '@/services/safeAxios';
import type { ApiPath as SafeURL } from '@/services/apiPath';

const logger = log.getLogger('api.utils');

export const httpReq = async <T, V>(
  url: SafeURL,
  body?: T,
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' = 'post',
): Promise<V> => {
  try {
    const res =
      method === 'get' || method === 'delete' ? await safeAxios[method]<V>(url) : await safeAxios[method]<V>(url, body);
    return res.data;
  } catch (e) {
    logger.error(`Error in ${method} request:`, e);
    throw e;
  }
};

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    return (error.response?.data as { message?: string })?.message || fallback;
  }
  return fallback;
}
